import { useQuery } from '@apollo/client';
import React from 'react';

import { CBCategories, CRUNCHBASE_CATEGORIES } from '../../graphql/queries/crunchbase';
import { MultiSelectForm } from './multi-select-form';

export const IndustriesForm: React.FC<{
    readonly: boolean;
    filters: string[];
    onChange: (val: string[]) => void;
}> = ({ readonly, filters, onChange }) => {
    const { data: optionsData } = useQuery<{ categories: CBCategories[] }>(CRUNCHBASE_CATEGORIES);

    const options = optionsData?.categories.map((c) => c.name) ?? [];

    return (
        <MultiSelectForm
            readonly={readonly}
            filters={filters}
            label="Categories"
            options={options}
            onChange={onChange}
        />
    );
};
